import { Feature, Geometry, MultiPolygon, Polygon } from 'geojson'
import calculateArea from '@turf/area'
import getIntersect from '@turf/intersect'
import difference from '@turf/difference'
import { featureCollection } from '@turf/helpers'
import truncate from '@turf/truncate'
import { colors } from '~/design'

export const MaskPolygonInDelimitation = (
  feature: Feature<Polygon | MultiPolygon, any>,
  delimitation: Polygon | MultiPolygon | undefined,
  renderRemainder: boolean = false,
): Feature<Polygon | MultiPolygon, any>[] => {
  try {
    const originalArea = calculateArea(feature.geometry)
    const truncateOptions = { precision: 8 }

    const intersection = delimitation
      ? getIntersect(
          featureCollection([
            truncate(feature, truncateOptions),
            {
              type: 'Feature',
              properties: {},
              geometry: truncate(delimitation, truncateOptions),
            } as Feature<Polygon | MultiPolygon>,
          ]),
          {
            properties: feature.properties,
          },
        )
      : feature.geometry

    const newFeature =
      intersection &&
      (intersection as Feature<Polygon | MultiPolygon>).geometry?.coordinates?.length
        ? (intersection as Feature<Polygon | MultiPolygon>)
        : feature
    const intersectionArea = calculateArea(newFeature)

    const preservedAreaPercentage = (intersectionArea / originalArea) * 100
    newFeature.properties!.preservedAreaPercentage = preservedAreaPercentage
    newFeature.properties!.zIndex += 10

    const finalFeatures = [newFeature]
    if (renderRemainder) {
      const remainder = delimitation
        ? difference(
            featureCollection([
              feature,
              {
                type: 'Feature',
                properties: {},
                geometry: delimitation,
              } as Feature<Polygon | MultiPolygon>,
            ]),
          )
        : null

      if (remainder) {
        const remainderFeature = {
          type: 'Feature',
          properties: {
            h3: feature.properties?.h3,
            value: '',
            fillColor: colors.darkGray,
            fillOpacity: 0.4,
            strokeColor: colors.darkGray,
            strokeWeight: feature.properties?.strokeWeight || 1,
            strokeOpacity: feature.properties?.strokeOpacity || 0.8,
            zIndex: 10,
            isRemainder: true,
            preservedAreaPercentage: 100 - preservedAreaPercentage,
          },
          geometry: remainder.geometry,
        } as Feature<Polygon | MultiPolygon>

        finalFeatures.push(remainderFeature)
      }
    }

    return finalFeatures
  } catch (error) {
    console.error(error)
    feature.properties!.preservedAreaPercentage = 100
    return [feature]
  }
}
